import * as types from '@/store/organization/mutationTypes';
import { createClearPropMutation, createSetPropMutation } from '@/store/utils';

export default {
  [types.SET_ORGANIZATIONS]: createSetPropMutation('organizations', []),
  [types.CLEAR_ORGANIZATIONS]: createClearPropMutation('organizations', []),
};
